import React, { useState } from 'react';
import './HeroSection.scss';
import getLifetimeCheckoutLink from 'services/Subscriprion/getLifetimeCheckoutLink';
import { trackLifetimeCheckoutClick } from 'utils/tracking';
import { useUser } from 'hooks/user';
import { useAppContext } from 'hooks/app';
import { Modals } from 'constants/modals';
import { useCaptureAbandonedCheckout } from 'hooks/abandonedCheckout';

const HeroSection: React.FC = () => {
  const [loading, setLoading] = useState(false);
  const { user } = useUser();
  const { openModal } = useAppContext();
  const { capture } = useCaptureAbandonedCheckout();

  const handleCTA = async () => {
    trackLifetimeCheckoutClick('Lifetime Plan', 0);
    if (!user?.id) {
      openModal?.(Modals.LEAD_CAPTURE, { planType: "4", planName: "Lifetime Plan" });
      return;
    }
    capture({ email: user.email, source: 'hero', plan: 'Lifetime Plan' });
    setLoading(true);
    try {
      const url = await getLifetimeCheckoutLink();
      window.location.href = url;
    } catch {
      setLoading(false);
    }
  };

  return (
    <section className="hero-section">
      <div className="container">
        {/* Scarcity Bar with Countdown/Count */}
        <div className="scarcity-timer-bar">
          <p>ON SELLERDASH's 3RD BIRTHDAY! WE ARE OFFERING 100 LIFETIME SUBSCRIPTIONS</p>
        </div>

        <h1 className="hero-headline">
          Secure Your Sellerdash <span className="highlight">Lifetime Access</span> for Just $99.99!
        </h1>
        <p className="hero-subheadline">
          Unlock Product Hunting Superpowers and **<b>Never Pay a Monthly Fee Again.</b>**
        </p>

        {/* Social Proof Block */}
        <div className="social-proof-block">
          <div className="proof-item">
            <span className="proof-value">50K+</span>
            <span className="proof-label">Sellers Boosted</span>
          </div>
          <div className="proof-item">
            <span className="proof-value">4.1/5</span>
            <span className="proof-label">Chrome Store Rating</span>
          </div>
          <div className="proof-item">
            <span className="proof-value">20K+</span>
            <span className="proof-label">Active Chrome Downloads</span>
          </div>
        </div>

        <button
          onClick={handleCTA}
          disabled={loading}
          className="cta-button primary-cta"
        >
          {loading ? 'Redirecting...' : 'Claim My Lifetime Plan Now'}
        </button>
      </div>
    </section>
  );
};

export default HeroSection;
